import { ApplyTarget } from './types';

export const emptyApplyToSelection = {
  area: [],
  city: [],
  property: []
};

export const emptyLookupOptions = {
  area: [],
  city: [],
  property: []
};

export const applyTargetOptions: { value: ApplyTarget; label: string }[] = [
  { value: 'area', label: 'Area' },
  { value: 'city', label: 'City' },
  { value: 'property', label: 'Property' }
];

export const applyTargetSelectLabel: Record<ApplyTarget, string> = {
  area: 'Select areas',
  city: 'Select cities',
  property: 'Select properties'
};

export const promoSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    minHeight: 74,
    borderRadius: 12,
    borderColor: state.isFocused ? '#1f9d63' : '#e5e7eb',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(31, 157, 99, 0.25)' : 'none',
    padding: '8px 14px',
    ':hover': {
      borderColor: state.isFocused ? '#1f9d63' : '#e5e7eb'
    }
  }),
  valueContainer: (base: any) => ({
    ...base,
    gap: 8,
    padding: 0
  }),
  multiValue: (base: any) => ({
    ...base,
    backgroundColor: '#ecfdf5',
    borderRadius: 8,
    padding: '6px 8px'
  }),
  multiValueLabel: (base: any) => ({
    ...base,
    color: '#065f46',
    fontSize: 14
  }),
  multiValueRemove: (base: any) => ({
    ...base,
    color: '#374151',
    ':hover': {
      backgroundColor: 'transparent',
      color: '#111827'
    }
  }),
  placeholder: (base: any) => ({
    ...base,
    color: '#d1d5db'
  }),
  menu: (base: any) => ({
    ...base,
    zIndex: 30,
    borderRadius: 12,
    overflow: 'hidden'
  }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected ? '#ecfdf5' : state.isFocused ? '#f9fafb' : '#ffffff',
    color: state.isSelected ? '#047857' : '#1f2937',
    fontSize: 14,
    padding: '14px 18px'
  })
};
